import { render, staticRenderFns } from "./Colom.vue?vue&type=template&id=4068a63e&scoped=true&"
import script from "./Colom.vue?vue&type=script&lang=js&"
export * from "./Colom.vue?vue&type=script&lang=js&"
import style0 from "./Colom.vue?vue&type=style&index=0&id=4068a63e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4068a63e",
  null
  
)

export default component.exports